<template>
  <div class="memberships__all">
    <div class="memberships__all__header">
      <h1 class="font-bold text-xl">Pricing</h1>
    </div>
    <div class="memberships__all__container">
      <Table :columns="columns" :data="plans">
        <template v-slot:id="scope">
          <Icon name="Document" />
          <p>{{ scope.item.id }}</p>
        </template>
        <template v-slot:name="scope">
          {{ scope.item.name }}
        </template>
        <template v-slot:period="scope">
          {{ scope.item.period }}
        </template>

        <template v-slot:price="scope">
          {{ scope.item.price }}
        </template>
        <template v-slot:discounted_price="scope">
          {{ scope.item.discounted_price }}
        </template>
        <template v-slot:use_discount="scope">
          <div class="memberships_tags">
            <a-tag color="green">
              {{ scope.item.use_discount }}
            </a-tag>
          </div>
        </template>
        <template v-slot:features="scope">
          {{ scope.item.features }}
        </template>
        <template v-slot:extras="scope">
          {{ scope.item.extras }}
        </template>
        <template v-slot:paddle_plan_id="scope">
          {{ scope.item.paddle_plan_id }}
        </template>
        <template v-slot:actions="scope">
          <router-link :to="`/pricing/edit/${scope.item.id}`">
            <a-button>Edit</a-button>
          </router-link>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import Table from "@/components/Table/index";

export default {
  components: { Table },
  setup() {
    const store = useStore();
    onMounted(() => {
      store.dispatch("GET_MEMBERSHIPS");
    });
    const columns = ref([
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
        style: {
          width: "300px",
          flex: "none",
        },
        slot: true,
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        slot: true,
      },
      {
        title: "Period",
        dataIndex: "period",
        key: "period",
        slot: true,
      },
      {
        title: "Price",
        dataIndex: "price",
        key: "price",
        slot: true,
      },
      {
        title: "Discounted Price",
        dataIndex: "discounted_price",
        key: "discounted_price",

        slot: true,
      },
      {
        title: "Use Discounted Price",
        dataIndex: "use_discount",
        key: "use_discount",
        slot: true,
      },
      {
        title: "Features",
        dataIndex: "features",
        key: "features",
        style: {
          width: "450px",
          flex: "none",
        },
        slot: true,
      },
      {
        title: "Extras",
        dataIndex: "extras",
        key: "extras",

        slot: true,
      },
      {
        title: "Paddle Plan Id",
        dataIndex: "paddle_plan_id",
        key: "paddle_plan_id",

        slot: true,
      },
      {
        title: "Actions",
        dataIndex: "actions",
        key: "actions",
        slot: true,
      },
    ]);

    const plans = computed(() => store.state.plans);


    return {
      columns,
      plans,
    };
  },
};
</script>

<style scoped>
.memberships__all {
  max-width: calc(100vw - 200px);
  margin: 0 auto;
  height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
}
.memberships_tags {
  position: absolute;
  width: 100%;
  height: 100%;
  display: grid;
  grid-auto-flow: column;
  gap: 5px;
  justify-content: start;
  align-items: center;
  overflow: hidden;
  padding-top: 5px;
}
.memberships__all__header {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.memberships__all__container {
  max-width: calc(100vw - 200px);
  height: calc(100vh - 80px);
}
.soon {
  @apply bg-yellow-500 text-white px-2;
}
.expired {
  @apply bg-red-500 text-white px-2;
}
</style>
